import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'seleccion-reportes',
  templateUrl: './seleccion-reportes.component.html',
  styleUrls: ['./seleccion-reportes.component.scss']
})
export class SeleccionReportesComponent implements OnInit {

  @ViewChild('modalGraficaAvanceFinanciero')
  public modalGraficaAvanceFinanciero: any;

  @ViewChild('modalSeguimientoPEF')
  public modalSeguimientoPEF: any;

  @ViewChild('modalPresupuestosProgramas')
  public modalPresupuestosProgramas: any;

  public modalActivo: NgbModalRef;

  public buscadorForm: FormGroup;
  public mostrarComponenteReporteEstados: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService
  ) { }

  async ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Reportes de presupuestos');
    this.inicializarForm();
  }

  public inicializarForm(): void {
    this.buscadorForm = this.formBuilder.group({
      tipoReporte: new FormControl('-1'),
    });

    this.buscadorForm.get('tipoReporte').valueChanges.subscribe(
      (tipoReporte: string) => {
        if (tipoReporte === '1') {
          this.mostrarComponenteReporteEstados = true;
        } else if (tipoReporte === '-1') {
          this.mostrarComponenteReporteEstados = false;
        } else if (tipoReporte === '2') {
          this.mostrarComponenteReporteEstados = false;
          this.modalGraficaAvanceFinanciero.abrirlModalGraficaAvanceFinanciero();
        } else if (tipoReporte === '3') {
          this.mostrarComponenteReporteEstados = false;
          this.modalSeguimientoPEF.abrirlModalSeguimientoPEF('ReporteCompleto');
        }
        else if (tipoReporte === '4') {
          this.mostrarComponenteReporteEstados = false;
          this.modalPresupuestosProgramas.abrirlModalPresupuestos();
        }
      }
    );
  }
}
